"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metric = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var chart_1 = require("../../../../state/actions/chart");
var get_accessibility_config_1 = require("../../../../state/selectors/get_accessibility_config");
var get_chart_theme_1 = require("../../../../state/selectors/get_chart_theme");
var get_internal_is_intialized_1 = require("../../../../state/selectors/get_internal_is_intialized");
var common_1 = require("../../../../utils/common");
var light_theme_1 = require("../../../../utils/themes/light_theme");
var specs_1 = require("../../specs");
var chart_size_1 = require("../../state/selectors/chart_size");
var data_1 = require("../../state/selectors/data");
var progress_1 = require("./progress");
var sparkline_1 = require("./sparkline");
var text_1 = require("./text");
var Component = (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.componentDidMount = function () {
        this.props.onChartRendered();
    };
    Component.prototype.componentDidUpdate = function () {
        this.props.onChartRendered();
    };
    Component.prototype.render = function () {
        var _a = this.props, chartId = _a.chartId, initialized = _a.initialized, _b = _a.size, width = _b.width, height = _b.height, a11y = _a.a11y, specs = _a.specs, style = _a.style;
        if (!initialized || specs.length === 0 || width === 0 || height === 0) {
            return null;
        }
        var data = specs[0].data;
        var maxRows = data.length;
        var maxColumns = data.reduce(function (acc, curr) {
            return Math.max(acc, curr.length);
        }, 0);
        var panel = { width: width / maxColumns, height: height / maxRows };
        return (react_1.default.createElement("div", { className: "echMetricContainer", "aria-labelledby": a11y.labelId, "aria-describedby": a11y.descriptionId, style: {
                gridTemplateColumns: "repeat(" + maxColumns + ", minmax(0, 1fr)",
                gridTemplateRows: "repeat(" + maxRows + ", minmax(64px, 1fr)",
            } }, data
            .map(function (columns, ri) {
            return __spreadArray(__spreadArray([], __read(columns.map(function (d, ci) {
                var metricHTMLId = "echMetric-" + chartId + "-" + ri + "-" + ci;
                var emptyMetricClassName = (0, classnames_1.default)('echMetric', {
                    'echMetric--rightBorder': ci < maxColumns - 1,
                    'echMetric--bottomBorder': ri < maxRows - 1,
                });
                if (!d) {
                    return react_1.default.createElement("div", { key: "empty-" + ci, className: emptyMetricClassName });
                }
                var hasProgressBar = (0, specs_1.isMetricWProgress)(d);
                var progressBarDirection = (0, specs_1.isMetricWProgress)(d) ? d.progressBarDirection : undefined;
                var metricPanelClassName = (0, classnames_1.default)(emptyMetricClassName, {
                    'echMetric--small': hasProgressBar,
                    'echMetric--vertical': progressBarDirection === common_1.LayoutDirection.Vertical,
                    'echMetric--horizontal': progressBarDirection === common_1.LayoutDirection.Horizontal,
                });
                return (react_1.default.createElement("div", { role: "figure", "aria-labelledby": d.title && metricHTMLId, key: "" + d.title + d.subtitle + d.color + ci, className: metricPanelClassName, style: {
                        backgroundColor: !(0, specs_1.isMetricWTrend)(d) && !(0, specs_1.isMetricWProgress)(d) ? d.color : style.background,
                    } },
                    react_1.default.createElement(text_1.MetricText, { id: metricHTMLId, datum: d, panel: panel, style: style }),
                    (0, specs_1.isMetricWTrend)(d) && react_1.default.createElement(sparkline_1.SparkLine, { id: metricHTMLId, datum: d }),
                    (0, specs_1.isMetricWProgress)(d) && react_1.default.createElement(progress_1.ProgressBar, { datum: d, barBackground: style.barBackground })));
            })), false), __read(Array.from({ length: maxColumns - columns.length }, function (d, ci) {
                var emptyMetricClassName = (0, classnames_1.default)('echMetric', {
                    'echMetric--rightBorder': columns.length + ci < maxColumns - 1,
                    'echMetric--bottomBorder': ri < maxRows - 1,
                });
                return react_1.default.createElement("div", { key: "missing-" + ci, className: emptyMetricClassName });
            })), false);
        })
            .flat()));
    };
    Component.displayName = 'Metric';
    return Component;
}(react_1.default.Component));
var mapDispatchToProps = function (dispatch) {
    return (0, redux_1.bindActionCreators)({
        onChartRendered: chart_1.onChartRendered,
    }, dispatch);
};
var DEFAULT_PROPS = {
    initialized: false,
    chartId: '',
    specs: [],
    size: {
        width: 0,
        height: 0,
    },
    a11y: get_accessibility_config_1.DEFAULT_A11Y_SETTINGS,
    style: light_theme_1.LIGHT_THEME.metric,
};
var mapStateToProps = function (state) {
    if ((0, get_internal_is_intialized_1.getInternalIsInitializedSelector)(state) !== get_internal_is_intialized_1.InitStatus.Initialized) {
        return DEFAULT_PROPS;
    }
    return {
        initialized: true,
        chartId: state.chartId,
        specs: (0, data_1.getMetricSpecs)(state),
        size: (0, chart_size_1.chartSize)(state),
        a11y: (0, get_accessibility_config_1.getA11ySettingsSelector)(state),
        style: (0, get_chart_theme_1.getChartThemeSelector)(state).metric,
    };
};
exports.Metric = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Component);
//# sourceMappingURL=index.js.map